import { render, staticRenderFns } from "./PersonalizationMicrosoftStep3.vue?vue&type=template&id=5b8119d8&scoped=true"
import script from "./PersonalizationMicrosoftStep3.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftStep3.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftStep3.vue?vue&type=style&index=0&id=5b8119d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8119d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8119d8')) {
      api.createRecord('5b8119d8', component.options)
    } else {
      api.reload('5b8119d8', component.options)
    }
    module.hot.accept("./PersonalizationMicrosoftStep3.vue?vue&type=template&id=5b8119d8&scoped=true", function () {
      api.rerender('5b8119d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/microsoft/PersonalizationMicrosoftStep3.vue"
export default component.exports